var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tab',{ref:"tab",staticClass:"p-0",attrs:{"title":"Apprenticeship","lazy":""}},[_c('apprenticeship-information'),_c('upgrade-information')],1)}
var staticRenderFns = []

export { render, staticRenderFns }